/**
 * Etichette leggibili per trigger, condizioni e azioni automazioni email.
 */

export function tagNameById(tags, id) {
  return tags.find((tg) => String(tg.id) === String(id))?.name || `#${id}`;
}

export function templateNameById(templates, id) {
  return templates.find((tpl) => String(tpl.id) === String(id))?.name || `#${id}`;
}

export function formatAutomationTriggerSummary({ triggerCode, triggerConfig = {}, triggerLabel, tags, t }) {
  let text = triggerLabel || triggerCode;
  if (triggerCode === 'tag.added' && triggerConfig.tag_id) {
    text += ` · ${tagNameById(tags, triggerConfig.tag_id)}`;
  }
  if (triggerCode === 'member.inactive') {
    text += ` · ${triggerConfig.days || 30} ${t('gym.email.automations.flowDays')}`;
  }
  if (triggerCode === 'subscription.expiring') {
    text += ` · ${triggerConfig.days_before ?? 7} ${t('gym.email.automations.flowDaysBefore')}`;
  }
  return text;
}

export function formatAutomationConditionLabel(cond, meta, tags) {
  const base = (meta.conditions || []).find((c) => c.code === cond.type)?.label || cond.type;
  if (cond.type === 'has_tag' || cond.type === 'not_has_tag') {
    return `${base}: ${tagNameById(tags, cond.tag_id)}`;
  }
  return base;
}

export function formatAutomationStepLabel(step, meta, tags, templates, t) {
  const act = (meta.actions || []).find((a) => a.code === step.action_type);
  const cfg = step.config || {};
  switch (step.action_type) {
    case 'tag.add':
      return `${act?.label || step.action_type} → ${tagNameById(tags, cfg.tag_id)}${
        cfg.duration_days ? ` (${cfg.duration_days}g)` : ''
      }`;
    case 'tag.remove':
      return `${act?.label || step.action_type} → ${tagNameById(tags, cfg.tag_id)}`;
    case 'wait':
      return `${act?.label || step.action_type}: ${cfg.days || 0}g ${cfg.hours || 0}h`;
    case 'email.send':
      return `${act?.label || step.action_type} → ${templateNameById(templates, cfg.template_id)}`;
    case 'stop':
      return act?.label || t('gym.email.automations.flowStop');
    default:
      return act?.label || step.action_type;
  }
}
